import React, { useState, useEffect } from 'react';
import Modal from '../../comun/Modal';
import printerService from '../../services/printerService';
import billingService from '../../services/billingService';


const Impresoras = () => {
    const [printers, setPrinters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingPrinter, setEditingPrinter] = useState(null);

    const initialPrinterState = {
        name: '',
        printer_type: 'thermal',
        connection_type: 'usb',
        connection_string: '',
        paper_width: 80,
        characters_per_line: 42,
        has_cash_drawer: true,
        is_active: true,
        is_default: false,
        config: { prints_receipt: true, prints_command: false }
    };

    const [printerForm, setPrinterForm] = useState(initialPrinterState);

    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
    const [settingsForm, setSettingsForm] = useState({
        company_name: '',
        company_address: '',
        company_phone: '',
        tax_id: '',
        obligation_contable: 'NO',
        contribuyente_regimen: '',
        artisan_qualification: '',
        receipt_header: '',
        receipt_footer: '',
        developer_credits: '',
        company_logo: '',
        koa_logo: ''
    });

    const fetchPrinters = async () => {
        try {
            setLoading(true);
            const data = await printerService.getPrinters();
            setPrinters(data.results || data || []);
            setError('');
        } catch (err) {
            console.error('Error fetching printers:', err);
            setError('Error al cargar las impresoras');
        } finally {
            setLoading(false);
        }
    };

    const handleImageUpload = (e, fieldName) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const maxWidth = fieldName === 'koa_logo' ? 120 : 250;
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height = Math.round((height * maxWidth) / width);
                    width = maxWidth;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                const optimizedBase64 = canvas.toDataURL('image/png');
                setSettingsForm(prev => ({
                    ...prev,
                    [fieldName]: optimizedBase64
                }));
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    };

    const fetchSettings = async () => {
        try {
            const billingData = await billingService.getConfig();
            const printerData = await printerService.getSettings().catch(() => null);

            setSettingsForm({
                company_name: billingData?.business_name !== undefined && billingData?.business_name !== null ? billingData.business_name : (printerData?.company_name || ''),
                company_address: billingData?.establishment_address !== undefined && billingData?.establishment_address !== null ? billingData.establishment_address : (printerData?.company_address || ''),
                company_phone: billingData?.company_phone !== undefined && billingData?.company_phone !== null ? billingData.company_phone : (printerData?.company_phone || ''),
                tax_id: billingData?.ruc !== undefined && billingData?.ruc !== null ? billingData.ruc : (printerData?.tax_id || ''),
                obligation_contable: billingData?.obligation_contable || 'NO',
                contribuyente_regimen: billingData?.contribuyente_regimen !== undefined && billingData?.contribuyente_regimen !== null ? billingData.contribuyente_regimen : '',
                artisan_qualification: billingData?.artisan_qualification !== undefined && billingData?.artisan_qualification !== null ? billingData.artisan_qualification : '',
                receipt_header: printerData?.receipt_header || '',
                receipt_footer: billingData?.footer_message !== undefined && billingData?.footer_message !== null ? billingData.footer_message : (printerData?.receipt_footer || ''),
                developer_credits: billingData?.developer_credits !== undefined && billingData?.developer_credits !== null ? billingData.developer_credits : '',
                company_logo: billingData?.company_logo || '',
                koa_logo: billingData?.koa_logo || ''
            });
        } catch (err) {
            console.error('Error fetching settings:', err);
        }
    };

    useEffect(() => {
        fetchPrinters();
        fetchSettings();
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPrinterForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleConfigChange = (e) => {
        const { name, checked } = e.target;
        setPrinterForm(prev => ({
            ...prev,
            config: {
                ...prev.config,
                [name]: checked
            }
        }));
    };

    const handleSettingsChange = (e) => {
        const { name, value } = e.target;
        setSettingsForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const openSettingsModal = () => {
        fetchSettings();
        setIsSettingsModalOpen(true);
    };

    const handleSettingsSubmit = async (e) => {
        e.preventDefault();
        try {
            // 1. Guardar en printer service
            await printerService.updateSettings({
                company_name: settingsForm.company_name,
                company_address: settingsForm.company_address,
                company_phone: settingsForm.company_phone,
                tax_id: settingsForm.tax_id,
                receipt_header: settingsForm.receipt_header,
                receipt_footer: settingsForm.receipt_footer
            });

            // 2. Guardar en ElectronicBillingConfig para sincronía total
            const currentBilling = await billingService.getConfig();
            await billingService.saveConfig({
                ...currentBilling,
                business_name: settingsForm.company_name,
                ruc: settingsForm.tax_id,
                establishment_address: settingsForm.company_address,
                company_phone: settingsForm.company_phone,
                obligation_contable: settingsForm.obligation_contable,
                contribuyente_regimen: settingsForm.contribuyente_regimen,
                artisan_qualification: settingsForm.artisan_qualification,
                footer_message: settingsForm.receipt_footer,
                developer_credits: settingsForm.developer_credits,
                company_logo: settingsForm.company_logo,
                koa_logo: settingsForm.koa_logo
            });

            setIsSettingsModalOpen(false);
            alert('Configuración del ticket guardada exitosamente');
        } catch (err) {
            console.error('Error saving settings:', err);
            alert('Error al guardar la configuración');
        }
    };



    const openNewModal = () => {
        setEditingPrinter(null);
        setPrinterForm(initialPrinterState);
        setIsModalOpen(true);
    };

    const openEditModal = (printer) => {
        setEditingPrinter(printer);
        setPrinterForm({
            name: printer.name || '',
            printer_type: printer.printer_type || 'thermal',
            connection_type: printer.connection_type || 'usb',
            connection_string: printer.connection_string || '',
            paper_width: printer.paper_width || 80,
            characters_per_line: printer.characters_per_line || 42,
            has_cash_drawer: printer.has_cash_drawer !== undefined ? printer.has_cash_drawer : true,
            is_active: printer.is_active !== undefined ? printer.is_active : true,
            is_default: printer.is_default !== undefined ? printer.is_default : false,
            config: {
                prints_receipt: printer.config?.prints_receipt !== undefined ? printer.config.prints_receipt : true,
                prints_command: printer.config?.prints_command !== undefined ? printer.config.prints_command : false
            }
        });
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingPrinter) {
                await printerService.updatePrinter(editingPrinter.id, printerForm);
            } else {
                await printerService.createPrinter(printerForm);
            }
            setIsModalOpen(false);
            fetchPrinters();
        } catch (err) {
            console.error('Error saving printer:', err);
            alert('Error al guardar la impresora. Verifique los datos.');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('¿Está seguro de eliminar esta impresora?')) {
            try {
                await printerService.deletePrinter(id);
                fetchPrinters();
            } catch (err) {
                console.error('Error deleting printer:', err);
                alert('Error al eliminar la impresora');
            }
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>Administración de Impresoras</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="btn btn-secondary" onClick={openSettingsModal}>
                        Configurar Ticket
                    </button>
                    <button className="btn btn-primary" onClick={openNewModal}>
                        Nueva Impresora
                    </button>
                </div>
            </div>

            {loading ? <div>Cargando impresoras...</div> : error ? <div className="alert alert-error">{error}</div> : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Tipo</th>
                                <th>Conexión</th>
                                <th>Papel (mm)</th>
                                <th>Caja</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {printers.length === 0 ? (
                                <tr><td colSpan="7">No hay impresoras registradas</td></tr>
                            ) : (
                                printers.map(printer => (
                                    <tr key={printer.id}>
                                        <td>{printer.name} {printer.is_default && <span style={{fontSize: '0.8em', color: 'green'}}>(Default)</span>}</td>
                                        <td>{printer.printer_type === 'thermal' ? 'Térmica' : printer.printer_type}</td>
                                        <td>{printer.connection_type === 'rawbt' ? 'App RawBT (Tablet)' : printer.connection_type.toUpperCase()}</td>
                                        <td>{printer.paper_width}mm</td>
                                        <td>{printer.has_cash_drawer ? 'Sí' : 'No'}</td>
                                        <td>{printer.is_active ? 'Activa' : 'Inactiva'}</td>
                                        <td>
                                            <button 
                                                className="btn btn-secondary" 
                                                onClick={() => openEditModal(printer)}
                                                style={{ marginRight: '5px', padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                            >
                                                Editar
                                            </button>
                                            <button 
                                                className="btn btn-danger" 
                                                onClick={() => handleDelete(printer.id)}
                                                style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={editingPrinter ? "Editar Impresora" : "Nueva Impresora"}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nombre de Impresora</label>
                        <input
                            type="text"
                            name="name"
                            value={printerForm.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Tipo de Conexión</label>
                        <select name="connection_type" value={printerForm.connection_type} onChange={handleInputChange} className="form-control">
                            <option value="usb">USB (Agente PC)</option>
                            <option value="network">Red / IP (Agente PC)</option>
                            <option value="bluetooth">Bluetooth (Agente PC)</option>
                            <option value="serial">Serial / COM (Agente PC)</option>
                            <option value="rawbt">Inalámbrica (App RawBT Tablet)</option>
                        </select>
                    </div>

                    {printerForm.connection_type !== 'rawbt' && (
                        <div className="form-group">
                            <label>Cadena de Conexión</label>
                            <input
                                type="text"
                                name="connection_string"
                                value={printerForm.connection_string}
                                onChange={handleInputChange}
                                placeholder="Ej: /dev/usb/lp0, 192.168.1.100, COM1"
                            />
                        </div>
                    )}

                    <div className="form-group" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1 1 140px' }}>
                            <label>Ancho de Papel (mm)</label>
                            <select name="paper_width" value={printerForm.paper_width} onChange={handleInputChange} className="form-control">
                                <option value="58">58mm</option>
                                <option value="80">80mm</option>
                            </select>
                        </div>
                        <div style={{ flex: '1 1 140px' }}>
                            <label>Caracteres por línea</label>
                            <input
                                type="number"
                                name="characters_per_line"
                                value={printerForm.characters_per_line}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="has_cash_drawer"
                                checked={printerForm.has_cash_drawer}
                                onChange={handleInputChange}
                                style={{ marginRight: '8px' }}
                            />
                            Tiene Caja Registradora
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="is_default"
                                checked={printerForm.is_default}
                                onChange={handleInputChange}
                                style={{ marginRight: '8px' }}
                            />
                            Es la Impresora Principal (Por Defecto)
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="is_active"
                                checked={printerForm.is_active}
                                onChange={handleInputChange}
                                style={{ marginRight: '8px' }}
                            />
                            Activa
                        </label>
                    </div>

                    <h4 style={{ margin: '1.5rem 0 0.5rem 0', color: 'var(--primary-color)' }}>Documentos a Imprimir</h4>
                    <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '1rem' }}>Seleccione qué documentos debe imprimir esta impresora</p>
                    
                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="prints_receipt"
                                checked={printerForm.config?.prints_receipt ?? true}
                                onChange={handleConfigChange}
                                style={{ marginRight: '8px' }}
                            />
                            Imprimir Factura/Ticket (Con detalles y precios para el cliente)
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="prints_command"
                                checked={printerForm.config?.prints_command ?? false}
                                onChange={handleConfigChange}
                                style={{ marginRight: '8px' }}
                            />
                            Imprimir Comanda (Sin precios, para cocina o preparación)
                        </label>
                    </div>

                    <div className="form-actions">
                        <button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>Cancelar</button>
                        <button type="submit" className="btn btn-primary">Guardar Impresora</button>
                    </div>
                </form>
            </Modal>

            <Modal isOpen={isSettingsModalOpen} onClose={() => setIsSettingsModalOpen(false)} title="Configuración del Ticket y Voucher SRI" maxWidth="850px">
                <form onSubmit={handleSettingsSubmit}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
                        <div>
                            {/* Carga de Logo de la Empresa */}
                            <div className="form-group" style={{ padding: '8px', border: '1px dashed #cbd5e1', borderRadius: '6px', backgroundColor: '#f8fafc' }}>
                                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
                                    <i className="bi bi-image" style={{ marginRight: '4px', color: '#4a7c59' }}></i> Logo Empresa (Cabecera Ticket)
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                        type="file"
                                        accept="image/png, image/jpeg, image/jpg"
                                        onChange={(e) => handleImageUpload(e, 'company_logo')}
                                        style={{ fontSize: '0.8rem' }}
                                    />
                                    {settingsForm.company_logo && (
                                        <button
                                            type="button"
                                            onClick={() => setSettingsForm({ ...settingsForm, company_logo: '' })}
                                            style={{ padding: '2px 6px', backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '4px', fontSize: '0.7rem', cursor: 'pointer' }}
                                        >
                                            Quitar
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Razón Social / Nombre Comercial</label>
                                <input type="text" name="company_name" value={settingsForm.company_name} onChange={handleSettingsChange} placeholder="Ej: SOPHIA´S COFFE" required />
                            </div>
                            <div className="form-group">
                                <label>RUC de la Empresa</label>
                                <input type="text" name="tax_id" value={settingsForm.tax_id} onChange={handleSettingsChange} placeholder="Ej: 0401788617001" required />
                            </div>
                            <div className="form-group">
                                <label>Dirección de Matriz / Establecimiento</label>
                                <input type="text" name="company_address" value={settingsForm.company_address} onChange={handleSettingsChange} placeholder="Ej: Av. Principal 123, Quito - Ecuador" required />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                <div className="form-group">
                                    <label>Obligado a Contabilidad</label>
                                    <select name="obligation_contable" value={settingsForm.obligation_contable} onChange={handleSettingsChange}>
                                        <option value="NO">NO</option>
                                        <option value="SI">SI</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Régimen Tributario</label>
                                    <input type="text" name="contribuyente_regimen" value={settingsForm.contribuyente_regimen} onChange={handleSettingsChange} placeholder="RIMPE - NEGOCIO POPULAR" />
                                </div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                <div className="form-group">
                                    <label>Teléfono (Opcional)</label>
                                    <input type="text" name="company_phone" value={settingsForm.company_phone} onChange={handleSettingsChange} placeholder="Ej: 0999999999" />
                                </div>
                                <div className="form-group">
                                    <label>Calificación Artesanal No. (Opcional)</label>
                                    <input type="text" name="artisan_qualification" value={settingsForm.artisan_qualification || ''} onChange={handleSettingsChange} placeholder="Ej: 123456" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Mensaje al Pie del Ticket (Voucher SRI)</label>
                                <textarea rows="2" name="receipt_footer" value={settingsForm.receipt_footer} onChange={handleSettingsChange} placeholder="Ej: ¡Gracias por su compra!..." style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }} />
                            </div>

                            {/* Carga de Logo Koa (Miniatura para el pie) */}
                            <div className="form-group" style={{ padding: '8px', border: '1px dashed #cbd5e1', borderRadius: '6px', backgroundColor: '#f8fafc' }}>
                                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
                                    <i className="bi bi-code-slash" style={{ marginRight: '4px', color: '#4a7c59' }}></i> Logo Desarrollador Koa (Miniatura Pie)
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                        type="file"
                                        accept="image/png, image/jpeg, image/jpg"
                                        onChange={(e) => handleImageUpload(e, 'koa_logo')}
                                        style={{ fontSize: '0.8rem' }}
                                    />
                                    {settingsForm.koa_logo && (
                                        <button
                                            type="button"
                                            onClick={() => setSettingsForm({ ...settingsForm, koa_logo: '' })}
                                            style={{ padding: '2px 6px', backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '4px', fontSize: '0.7rem', cursor: 'pointer' }}
                                        >
                                            Quitar
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Créditos de Desarrollador / Web</label>
                                <input type="text" name="developer_credits" value={settingsForm.developer_credits || ''} onChange={handleSettingsChange} placeholder="Sistema desarrollado por Koa | WhatsApp: ... | www..." style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }} />
                            </div>
                        </div>

                        {/* Vista previa en vivo del ticket dentro del modal */}
                        <div>
                            <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#374151' }}>
                                <i className="bi bi-eye-fill"></i> Vista Previa en Vivo (80mm)
                            </label>
                            <div style={{
                                backgroundColor: '#fdfdfd',
                                padding: '16px 12px',
                                border: '1px solid #cbd5e1',
                                borderRadius: '4px',
                                fontFamily: '"Courier New", Courier, monospace',
                                fontSize: '11px',
                                color: '#000',
                                lineHeight: 1.25,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                            }}>
                                <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                    {settingsForm.company_logo && (
                                        <div style={{ marginBottom: '6px' }}>
                                            <img
                                                src={settingsForm.company_logo}
                                                alt="Logo Empresa"
                                                style={{ maxWidth: '120px', maxHeight: '60px', objectFit: 'contain', filter: 'grayscale(100%) contrast(150%)' }}
                                            />
                                        </div>
                                    )}
                                    <div style={{ fontSize: '13px', fontWeight: 'bold' }}>{settingsForm.company_name || 'EMPRESA'}</div>
                                    {settingsForm.tax_id && <div>RUC: {settingsForm.tax_id}</div>}
                                    {settingsForm.company_address && <div>{settingsForm.company_address}</div>}
                                    {settingsForm.company_phone && <div>Telf: {settingsForm.company_phone}</div>}
                                    <div style={{ fontSize: '9px', marginTop: '2px' }}>Obligado a contabilidad: {settingsForm.obligation_contable}</div>
                                    {settingsForm.contribuyente_regimen && <div style={{ fontSize: '9px' }}>CONTRIBUYENTE {settingsForm.contribuyente_regimen}</div>}
                                    {settingsForm.artisan_qualification && <div style={{ fontSize: '9px' }}>CALIFICACIÓN ARTESANAL NO. {settingsForm.artisan_qualification}</div>}
                                </div>
                                <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                    <div style={{ fontWeight: 'bold', textAlign: 'center' }}>FACTURA ELECTRÓNICA</div>
                                    <div>No: 001-001-000000129</div>
                                    <div>Fecha: {new Date().toLocaleDateString('es-EC')} {new Date().toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' })}</div>
                                    <div>Estado: <strong>AUTORIZADO</strong></div>
                                    <div>Cliente: CONSUMIDOR FINAL</div>
                                    <div>RUC/CI: 9999999999999</div>
                                </div>
                                <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
                                        <span>1x Producto Demo</span>
                                        <span>$2.61</span>
                                    </div>
                                </div>
                                <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>SUBTOTAL:</span>
                                        <span>$2.61</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>IVA:</span>
                                        <span>$0.39</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '12px', marginTop: '2px' }}>
                                        <span>TOTAL A PAGAR:</span>
                                        <span>$3.00</span>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                    <div style={{ fontSize: '9px', fontWeight: 'bold' }}>CLAVE DE ACCESO:</div>
                                    <div style={{ fontSize: '8px', wordBreak: 'break-all' }}>2408202601040178861700110010010000001291234567818</div>
                                </div>
                                {settingsForm.receipt_footer && (
                                    <div style={{ textAlign: 'center', fontSize: '9px', whiteSpace: 'pre-line', marginBottom: '4px' }}>
                                        {settingsForm.receipt_footer}
                                    </div>
                                )}
                                {(settingsForm.developer_credits || settingsForm.koa_logo) && (
                                    <div style={{ textAlign: 'center', fontSize: '8.5px', color: '#555', borderTop: '1px dotted #888', paddingTop: '4px' }}>
                                        {settingsForm.koa_logo && (
                                            <div style={{ marginBottom: '3px' }}>
                                                <img
                                                    src={settingsForm.koa_logo}
                                                    alt="Logo Koa"
                                                    style={{ maxWidth: '70px', maxHeight: '30px', objectFit: 'contain', filter: 'grayscale(100%) contrast(150%)' }}
                                                />
                                            </div>
                                        )}
                                        {settingsForm.developer_credits && <div>{settingsForm.developer_credits}</div>}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>



                    <div className="form-actions" style={{ marginTop: '20px' }}>
                        <button type="button" className="btn btn-secondary" onClick={() => setIsSettingsModalOpen(false)}>Cancelar</button>
                        <button type="submit" className="btn btn-primary">
                            <i className="bi bi-save-fill"></i> Guardar y Sincronizar con SRI
                        </button>
                    </div>
                </form>
            </Modal>

        </div>
    );
};

export default Impresoras;

const styles = `
    .page-container {
        padding: 20px;
        max-width: 1600px;
        margin: 0 auto;
    }
    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }
    .page-header h2 {
        margin: 0;
        color: #1f2937;
    }
    
    .btn {
        padding: 0.5rem 1rem;
        border-radius: 0.375rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        border: 1px solid transparent;
    }
    .btn-primary {
        background-color: var(--primary-color);
        color: white;
        border-color: var(--primary-color);
    }
    .btn-primary:hover {
        background-color: var(--primary-color, #4a1f0c);
    }
    .btn-secondary {
        background-color: var(--sidebar-bg);
        color: #374151;
        border-color: #d1d5db;
    }
    .btn-secondary:hover {
        background-color: #e5e7eb;
    }
    .btn-danger {
        background-color: #fee2e2;
        color: #dc2626;
        border-color: #fca5a5;
    }
    .btn-danger:hover {
        background-color: #fecaca;
    }

    /* Table */
    .table-responsive {
        width: 100%;
        overflow-x: auto;
        overflow-y: auto;
        max-height: 70vh;
        -webkit-overflow-scrolling: touch;
        border-radius: 0.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        border: 1px solid #e5e7eb;
        position: relative;
    }
    .table {
        width: 100%;
        border-collapse: collapse;
        background-color: white;
        min-width: 600px; 
    }
    .table th, .table td {
        padding: 0.75rem 1rem;
        text-align: left;
        border-bottom: 1px solid #e5e7eb;
    }
    .table th {
        background-color: var(--sidebar-bg);
        font-weight: 600;
        color: #374151;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        position: sticky;
        top: 0;
        z-index: 10;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    .table td {
        font-size: 0.875rem;
        color: #4b5563;
    }

    /* Form */
    .form-group {
        margin-bottom: 1rem;
    }
    .form-group label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: #374151;
    }
    .form-control, input[type="text"], input[type="number"], select {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #d1d5db;
        border-radius: 0.375rem;
        font-size: 1rem;
        box-sizing: border-box;
    }
    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .alert {
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 0.375rem;
    }
    .alert-error {
        background-color: #fee2e2;
        color: #991b1b;
        border: 1px solid #fecaca;
    }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
